import { PDFViewer } from '../../utilities/PDFViewer'
import { useEffect } from 'react'

import electronicDocument from '../../assets/electronic.pdf'
import privacyDocument from '../../assets/privacy.pdf'
import { company } from '../../utilities/CustomerData'

export default function TermsAndConditions() {
  useEffect(() => {
    document.title = `${company.companyName} | Terms and Conditions`
  }, [])
  
  return (
    <div className='flex flex-col items-center justify-center'>
      <p className='text-2xl font-bold mt-10 mb-10'>Terms and Conditions</p>
      <div className='w-1/2 flex justify-center border border-gra-300 rounded-md'>
        <PDFViewer file={electronicDocument} />
      </div>
      <div className='w-1/2 flex justify-center border border-gra-300 rounded-md'>
        <PDFViewer file={privacyDocument} />
      </div>
    </div>
  )
}